import { createStore } from 'owa-satcheljs';
import type { LeftNavIrisState } from './schema/leftNavIrisState';

export const getLeftNavStore: () => LeftNavIrisState = createStore<LeftNavIrisState>(
    'LeftNavIrisState',
    {
        header: '',
        body: '',
        userRedirectionUrl: '',
        textColor: '',
        iconRegular: '',
        iconDark: '',
        irisPrmId: '',
        trackingBaseUri: '',
        impressionBaseUri: '',
    }
);
